import { render, staticRenderFns } from "./agentFenxiaoCopy.vue?vue&type=template&id=a7477d04&scoped=true"
import script from "./agentFenxiaoCopy.vue?vue&type=script&lang=js"
export * from "./agentFenxiaoCopy.vue?vue&type=script&lang=js"
import style0 from "./agentFenxiaoCopy.vue?vue&type=style&index=0&id=a7477d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7477d04",
  null
  
)

export default component.exports